module.exports = __webpack_public_path__ + "static/media/7-cubes-h.5a00e665.png";